export const GoogleAnalyticsCode = 'G-SX1PW7J0EJ';
const linkedinPartnerID = '5595914';

export const LinkedinInsightTag = () => {
  const s = document.getElementsByTagName('script')[0];
  const b = document.createElement('script');
  b.type = 'text/javascript';
  b.async = true;
  b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
  s.parentNode.insertBefore(b, s);

  window.linkedin_partner_id = linkedinPartnerID;
  window.linkedin_data_partner_ids = window.linkedin_data_partner_ids || [];
  window.linkedin_data_partner_ids.push(window.linkedin_partner_id);
};

export default GoogleAnalyticsCode;



// WEBPACK FOOTER //
// ./src/assets/env.js